module.exports = __webpack_public_path__ + "img/seaPalace-3.d7493548.jpg";